import {
    Component,
    EventEmitter,
    Input,
    OnChanges,
    OnInit,
    Output,
} from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router } from "@angular/router";
import { AccountSettingService } from "src/app/Services/account-setting.service";
import { HomePageService } from "src/app/Services/home-page.service";
import { LoginUsersService } from "src/app/Services/login-users.service";
import { StaticPagesService } from "src/app/Services/static-pages.service";

import { TranslateService } from "@ngx-translate/core";

import { CheckoutService } from "../../../Services/checkout.service";
import { EmbryoService } from "../../../Services/Embryo.service";
import { ReactivityService } from "../../../Services/reactivity.service";
import { MarketingService } from "src/app/Services/marketing.service";

// import { environmentVariables } from 'src/environments/enviromentalVariables';

@Component({
    selector: "embryo-ProductGrid",
    templateUrl: "./ProductGrid.component.html",
    styleUrls: ["./ProductGrid.component.scss"],
})
export class ProductGridComponent implements OnInit, OnChanges {
    @Input("products") products: any;
    @Input("totalPage") totalPage: any;
    @Input("currentPage") currentPage: any;
    @Input("pageSize") pageSize: any;
    @Input() variantsLimit: number = 2;
    public count: any;
    public page: any;
    public total = 0;

    @Input() currency: string = "";
    @Input() gridLength: any;
    @Input() gridThree: boolean = false;
    @Input() isGridView: any;
    @Output() addToWishList: EventEmitter<any> = new EventEmitter();

    loaded = false;
    lg = 25;
    xl = 25;
    ChoosenOptionalImage: any;
    variant: any;
    showMainImage: boolean = false;
    lang: any;
    available_value_color = [];
    user: any;
    wishListProducts: any;
    currentFavProduct: any;
    productList: any;
    toggleLoading: boolean = false;
    toggleCompareLoading: boolean = false;
    toggleCartLoading: boolean = false;
    environmentVariables: any;
    redirectToProduct: boolean = false;
    noPricecontent: string = " ";
    constructor(
        private translate: TranslateService,
        private router: Router,
        public embryoService: EmbryoService,
        public snackBar: MatSnackBar,
        public HomeService: HomePageService,
        private reactivityService: ReactivityService,
        public checkoutService: CheckoutService,
        public userLoginServies: LoginUsersService,
        private account: AccountSettingService,
        private confgServ: StaticPagesService,
        private marketingService: MarketingService
    ) {
        this.getInitilizingData();
        embryoService.emitLang.subscribe((lang: string) => {
            translate.setDefaultLang(lang);
            this.lang = lang;
        });

        embryoService.favouritesListSub.subscribe((data) => {
            this.wishListProducts = data;
            if (this.products && data) {
                this.products.forEach((element: any) => {
                    const indexFavorite = data.findIndex(
                        (item: any) => item.id == element.id
                    );
                    element.is_favourite = indexFavorite !== -1;
                    element.favouriteLoading = false;
                });
            }
        });

        embryoService.compareListSub.subscribe((data) => {
            this.wishListProducts = data;
            if (this.products && data) {
                this.products.forEach((element: any) => {
                    const index = data.findIndex(
                        (item: any) => item.id == element.id
                    );
                    element.is_compare = index !== -1;
                    element.compareLoading = false;
                });
            }
        });
    }

    getInitilizingData() {
        this.confgServ.getenvConfig().subscribe((res) => {
            this.environmentVariables = res;
            this.redirectToProduct =
                this.environmentVariables?.PRODUCT_TYPE == "main";
        });
    }

    ngOnInit() {
        /*this.embryoService.favouritesListSub.subscribe((res) => {
      this.wishListProducts = res;
    });*/
        this.embryoService.productCartSub.subscribe(
            (res) => (this.productList = res)
        );

        /*this.products.forEach((product) => (product.routingName = encodeURIComponent(product.name.replace(/\s/g, '-'))));*/

        const wishlist_items =
            JSON.parse(<string>localStorage.getItem("wishListItems")) || [];

        this.lang = localStorage.getItem("lang");
        this.translate.setDefaultLang(this.lang);
        if (this.products.length) {
            this.products.forEach((element: any) => {
                element.productImageBackup = element.image;
                element.routingName = encodeURIComponent(
                    element.name.replace(/\s/g, "-")
                );
                element["compareLoading"] = false;
                if (this.userLoginServies.isGuest()) {
                    const ind = wishlist_items.findIndex(
                        (wi: any) => wi.id == element.id
                    );
                    if (ind !== -1) {
                        element.is_favourite = true;
                    }
                }

                if (element.product_variants.length) {
                    element.image = element.product_variants[0].image;
                    element.images = element.product_variants[0].images;
                    element.price = element.product_variants[0].price;
                    element.preorder_price =
                        element.product_variants[0].preorder_price;
                    element.discount_price =
                        element.product_variants[0].discount_price;
                }

                // this.checkIfProductInCompareList(element)

                element.available_value_color = [];
                element.product_variants.forEach((product_variant: any) => {
                    product_variant.options.forEach((option: any) => {
                        if (option.option.type == "4") {
                            option.values.find((value: any) => {
                                element.available_value_color.push(value);
                                element.available_value_color =
                                    element.available_value_color.filter(
                                        (
                                            color: any,
                                            index: number,
                                            color2: any
                                        ) =>
                                            index ===
                                            color2.findIndex(
                                                (t: any) => t.id === color.id
                                            )
                                    );
                            });
                        }
                    });
                });
                if (this.wishListProducts && this.wishListProducts.length) {
                    const indexFavorite = this.wishListProducts.findIndex(
                        (item: any) => item.parent_id == element.id
                    );
                    if (indexFavorite !== -1) {
                        element.is_favorite = true;
                    } else {
                        element.is_favorite = false;
                    }
                }
            });
        }
        if (this.gridThree) {
            this.lg = 33;
            this.xl = 33;
        }
        this.user = this.userLoginServies.getUser();
    }

    ngOnChanges() {
        this.products.forEach((product: any) => {
            product.toggleCartLoading = false;
            product.routingName = encodeURIComponent(
                product.name.replace(/\s/g, "-")
            );

            if (
                this.userLoginServies.isGuest() &&
                localStorage.getItem("compareItems")
            ) {
                let index = JSON.parse(
                    <string>localStorage.getItem("compareItems")
                ).findIndex((item: any) => item.id == product.id);
                product.is_compare = index !== -1;
            }
        });

        if (this.products && this.products.length) {
            this.products.forEach((element: any) => {
                if (element.product_variants.length) {
                    element.image = element.product_variants[0].image;
                    element.images = element.product_variants[0].images;
                    element.price = element.product_variants[0].price;
                    element.preorder_price =
                        element.product_variants[0].preorder_price;
                    element.discount_price =
                        element.product_variants[0].discount_price;
                }
                element.available_value_color = [];
                element.product_variants.forEach((product_variant: any) => {
                    product_variant.options.forEach((option: any) => {
                        if (option.option.type == "4") {
                            option.values.find((value: any) => {
                                element.available_value_color.push(value);
                                element.available_value_color =
                                    element.available_value_color.filter(
                                        (
                                            color: any,
                                            index: number,
                                            color2: any
                                        ) =>
                                            index ===
                                            color2.findIndex(
                                                (t: any) => t.id === color.id
                                            )
                                    );
                            });
                        }
                    });
                });
                if (this.wishListProducts && this.wishListProducts.length) {
                    this.wishListProducts.forEach((wishlist_product: any) => {
                        if (wishlist_product.parent_id == element.id) {
                            element.is_favorite = true;
                        } else {
                            element.is_favorite = false;
                        }
                    });
                }
            });
        }
    }

    switchMainImage(product: any, image: any) {
        product.image = image?.image;
    }
    originalImage(product: any): void {
        product.image = product.productImageBackup;
    }

    googleAnalaticSelectItem(product: any) {
        let obj = {
            item_name: product.name,
            item_id: product.id,
            price: product.discount_price
                ? product.discount_price
                : product.price,
            item_brand:
                product.details && product.details.brand
                    ? product.details.brand.name
                    : "",
            item_category: product.category ? product.category.name : "-",
            item_category2: product.category
                ? product.category.sub_categories
                    ? product.category.sub_categories[0].name
                    : "-"
                : "-",
            item_list_name: product.actegory ? product.actegory.id : "",
            item_list_id: product.actegory ? product.actegory.name : "",
            index: "",
        };
        let result = {
            event: "select_item",
            ecommerce: {
                items: obj,
                extras: this.account.googleAnalaticsUserData,
            },
        };
        // window['dataLayer'].push(result);
    }

    public onLoad() {
        this.loaded = true;
    }

    addToFavouriteList(variant: any, productType: string) {
        // variant.is_favourite = !variant.is_favourite;
        variant.favouriteLoading = true;
        if (!variant.is_favourite) {
            this.reactivityService.setDataToStore("currentFavProduct", variant);
            this.marketingService.cartEvents("add_to_wishlist", variant);
        } else {
            this.reactivityService.setDataToStore(
                "currentUnFavouriteProduct",
                variant
            );
        }
        if (productType == "main") {
            variant.is_favourite = !variant.is_favourite;
        }
    }

    addToCompareList(variant: any) {
        variant.compareLoading = true;
        !variant.is_compare
            ? this.reactivityService.setDataToStore(
                  "addProductToCompare",
                  variant
              )
            : this.reactivityService.setDataToStore(
                  "removeProductFromCompare",
                  variant
              );
        if (this.environmentVariables?.PRODUCT_TYPE == "main") {
            variant.is_compare = !variant.is_compare;
        }
    }

    setImage(img: any) {
        this.ChoosenOptionalImage = img;
    }

    setChossenData(product: any, id: number) {
        // this.variant = this.filterVariantByValue(id, product);
        // this.showMainImage = false;
        // this.ChoosenOptionalImage = this.variant.image;
        // product.image = this.variant.image;
        // product.name = this.variant.name;
        // product.price = this.variant.price;
        // product.discount_price = this.variant.discount_price;
        // product.variant_select = this.variant;
        let variant = this.filterVariantByValue(id, product);
        this.switchMainImage(product, variant);
    }

    public onPageChanged(event: any) {
        this.page = event;
        // this.search$.next(this.filter);
        // this.getAllProducts();
    }

    filterVariantByValue(id: number, product: any) {
        for (let i = 0; i < product?.product_variants?.length; i++) {
            //  this.VariantChossenArray.push(variant);
            // this.optionArray = product.product_variants[i].option;
            for (
                let y = 0;
                y < product?.product_variants[i]?.options?.length;
                y++
            ) {
                for (
                    let x = 0;
                    x <
                    product?.product_variants[i]?.options[y]?.values?.length;
                    x++
                ) {
                    if (
                        product?.product_variants[i]?.options[y]?.values[x]
                            ?.id === id
                    ) {
                        return product?.product_variants[i];
                    }
                }
            }
        }
    }

    notifyProduct(product: any) {
        this.user = JSON.parse(<string>localStorage.getItem("auth_user_crocs"));
        if (!this.user) {
            if (localStorage.getItem("lang") === "en") {
                this.snackBar.open(
                    "Please, Login first! so that you can Notify product",
                    "×",
                    {
                        panelClass: "error",
                        verticalPosition: "top",
                        duration: 3000,
                    }
                );
            } else {
                this.snackBar.open(
                    "الرجاء تسجيل الدخول أولا! بحيث يمكنك تفعيل التنبيه ",
                    "×",
                    {
                        panelClass: "error",
                        verticalPosition: "top",
                        duration: 3000,
                    }
                );
            }
            this.router.navigate(["/" + this.lang + "/session/signin"]);
        } else {
            product["toggleCartLoading"] = true;
            this.embryoService
                .PostRequestById("products/notify", product.id, product.id)
                .subscribe((response: any) => {
                    product["toggleCartLoading"] = false;
                    if (response.code === 200) {
                        if (localStorage.getItem("lang") === "en") {
                            this.snackBar.open(
                                "You will be notified when the item is available",
                                "×",
                                {
                                    panelClass: "success",
                                    verticalPosition: "top",
                                    duration: 3000,
                                }
                            );
                        } else {
                            this.snackBar.open(
                                "سوف يتم تبيهك عندما يكون المنتج متوفر",
                                "×",
                                {
                                    panelClass: "success",
                                    verticalPosition: "top",
                                    duration: 3000,
                                    direction: "rtl",
                                }
                            );
                        }
                    }
                });
        }
    }

    public addToCart(value: any) {
        this.embryoService.addToCartGuest(value);
    }
    

    getRate(product : any){
        let stringWithQuotes = product?.rate;
        let numberValue = parseFloat(stringWithQuotes);
        let roundedValue = Math.round(numberValue * 10) / 10;
        return roundedValue
    }
}
